<template>
  <div id="app">
    <main>
      <router-view :key="$route.fullPath"></router-view>
    </main>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Pusher from "pusher-js";
import {cloneDeep} from "lodash";

export default {
  name: 'App',

    data() {
        return {
            channel: null,
            pusher: null,

        }
    },


    mounted () {

        this.subscribe()
        this.get_branch_pending_tasks()
    },


    beforeDestroy() {
        if (this.channel) {
            this.channel.unbind_all();
            this.channel.unsubscribe();
        }
        if (this.pusher) {
            this.pusher.disconnect();
        }
    },
    methods: {
        ...mapActions('branch_tasks', ['get_branch_pending_tasks','set_tasks','get_tasks']),
        subscribe () {
            this.pusher = new Pusher('a307209c996aa89f7024', { cluster: 'ap2' })

            this.channel = this.pusher.subscribe('tasks')
            this.channel.bind('task.created', data => {

                this.get_tasks()
                this.get_branch_pending_tasks()


            })
            this.channel.bind('task.submitted', data => {
                this.get_tasks()
                this.get_branch_pending_tasks()
            })
            this.channel.bind('task.approved', data => {
                this.get_tasks()
                this.get_branch_pending_tasks()
            })
            this.channel.bind('task.deleted', data => {
                this.get_tasks()
                this.get_branch_pending_tasks()
            })
        },




    },
    computed:{

        ...mapState('branch_tasks',['branch_pending_tasks','tasks']),

        authenticatedUser() {
            let user = localStorage.getItem('user');
            user=  JSON.parse(user)
            return user
        },


    }
}
</script>

<style>
</style>
